import styled from 'styled-components';
import { useFileAttachmentCard } from './useFileAttachmentCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardButton = styled.button.withConfig({
  displayName: "FileAttachmentCard__CardButton"
})(["display:flex;align-items:center;gap:", ";padding:", ";max-width:360px;width:fit-content;border:1px solid ", ";border-radius:", ";background:", ";cursor:pointer;font-family:inherit;text-align:left;&:hover{background:", ";}"], ({
  theme
}) => theme.spotlight.spacing.sm, ({
  theme
}) => theme.spotlight.spacing.sm, ({
  theme
}) => theme.spotlight.color.border, ({
  theme
}) => theme.spotlight.borderRadius.sm, ({
  theme
}) => theme.spotlight.color.surface, ({
  theme
}) => theme.spotlight.color.bg);
const IconWrapper = styled.div.withConfig({
  displayName: "FileAttachmentCard__IconWrapper"
})(["flex-shrink:0;color:", ";display:flex;"], ({
  theme
}) => theme.spotlight.color.mutedChrome);
const FileInfo = styled.div.withConfig({
  displayName: "FileAttachmentCard__FileInfo"
})(["flex:1;min-width:0;"]);
const FileName = styled.p.withConfig({
  displayName: "FileAttachmentCard__FileName"
})(["margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:", ";color:", ";"], ({
  theme
}) => theme.spotlight.typography.fontSize.xl, ({
  theme
}) => theme.spotlight.color.ink);
const FileType = styled.p.withConfig({
  displayName: "FileAttachmentCard__FileType"
})(["margin:0;font-size:", ";color:", ";"], ({
  theme
}) => theme.spotlight.typography.fontSize.xs, ({
  theme
}) => theme.spotlight.color.muted);
const FileAttachmentCard = ({
  fileMetadata
}) => {
  const {
    buttonRef,
    buttonProps,
    ariaLabel,
    FileIconComponent,
    extensionLabel,
    displayName
  } = useFileAttachmentCard(fileMetadata);
  return /*#__PURE__*/_jsxs(CardButton, Object.assign({}, buttonProps, {
    ref: buttonRef,
    "aria-label": ariaLabel,
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      children: /*#__PURE__*/_jsx(FileIconComponent, {
        width: 24,
        height: 24
      })
    }), /*#__PURE__*/_jsxs(FileInfo, {
      children: [/*#__PURE__*/_jsx(FileName, {
        title: displayName,
        children: displayName
      }), extensionLabel && /*#__PURE__*/_jsx(FileType, {
        children: extensionLabel
      })]
    })]
  }));
};
FileAttachmentCard.displayName = 'FileAttachmentCard';
export default FileAttachmentCard;